import { render, staticRenderFns } from "./Pdtest.vue?vue&type=template&id=2c14e69e&scoped=true"
import script from "./Pdtest.vue?vue&type=script&lang=js"
export * from "./Pdtest.vue?vue&type=script&lang=js"
import style0 from "./Pdtest.vue?vue&type=style&index=0&id=2c14e69e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14e69e",
  null
  
)

export default component.exports